const headers = [
  {
    'id': 'id',
    'text': 'ID',
    'display': false,
    'sorted': false,
    'descending': false
  },
  {
    'id': 'lastname',
    'text': 'Nom',
    'display': true,
    'sorted': false,
    'descending': false
  },
  {
    'id': 'firstname',
    'text': 'Pr\u00e9nom',
    'display': true,
    'sorted': false,
    'descending': false
  },
  {
    'id': 'email',
    'text': 'Emails',
    'display': true,
    'sorted': false,
    'descending': false
  },
  {
    'id': 'address',
    'text': 'Adresses',
    'display': false,
    'sorted': false,
    'descending': false
  },
  {
    'id': 'organization',
    'text': 'Organisations',
    'display': true,
    'sorted': false,
    'descending': false
  },
  {
    'id': 'cat',
    'text': 'Groupes',
    'display': true,
    'sorted': false,
    'descending': false
  },
  {
    'id': 'phone',
    'text': 'T\u00e9l\u00e9phones',
    'display': false,
    'sorted': false,
    'descending': false
  },
  {
    'id': 'website',
    'text': 'Sites web',
    'display': false,
    'sorted': false,
    'descending': false
  }
]

const headers_org = [
  {
    'id': 'id',
    'text': 'ID',
    'display': false,
    'sorted': false,
    'descending': false
  },
  {
    'id': 'lastname',
    'text': 'Nom',
    'display': true,
    'sorted': false,
    'descending': false
  },
  {
    'id': 'firstname',
    'text': 'Acronyme',
    'display': true,
    'sorted': false,
    'descending': false
  },
  {
    'id': 'email',
    'text': 'Emails',
    'display': true,
    'sorted': false,
    'descending': false
  },
  {
    'id': 'address',
    'text': 'Adresses',
    'display': false,
    'sorted': false,
    'descending': false
  },
  {
    'id': 'cat',
    'text': 'Groupes',
    'display': false,
    'sorted': false,
    'descending': false
  },
  {
    'id': 'phone',
    'text': 'T\u00e9l\u00e9phones',
    'display': false,
    'sorted': false,
    'descending': false
  },
  {
    'id': 'website',
    'text': 'Sites web',
    'display': false,
    'sorted': false,
    'descending': false
  }
]

const search_fields = [
  {
    icon: 'profile',
    id: '*',
    text: 'Tous les champs'
  },
  {
    icon: 'user-circle-o',
    id: 'lastname',
    text: 'Nom'
  },
  {
    icon: 'face',
    id: 'firstname',
    text: 'Prénom'
  },
  {
    icon: 'mail_outline',
    id: 'email',
    text: 'Email'
  },
  {
    icon: 'home3',
    id: 'address',
    text: 'Adresse'
  },
  {
    icon: 'institution',
    id: 'organization',
    text: 'Organisation'
  },
  // {
  //   icon: 'user-tie',
  //   id: 'role',
  //   text: 'Rôle'
  // },
  {
    // icon: 'folder_shared',
    icon: 'tags',
    id: 'cat',
    text: 'Groupe'
  },
  {
    icon: 'phone2',
    id: 'phone',
    text: 'Numéro'
  }
]
const search_fields_org = [
  {
    icon: 'profile',
    id: '*',
    text: 'Tous les champs'
  },
  {
    icon: 'institution',
    id: 'name',
    text: 'Nom/Acronyme'
  },
  {
    icon: 'mail_outline',
    id: 'email',
    text: 'Email'
  },
  {
    icon: 'home3',
    id: 'address',
    text: 'Adresse'
  },
  {
    // icon: 'folder_shared',
    icon: 'tags',
    id: 'cat',
    text: 'Groupe'
  },
  {
    icon: 'phone2',
    id: 'phone',
    text: 'Numéro'
  }
]

const search_modes = [
  {
    icon: 'asterisk',
    id: '%.%',
    text: 'Contient...'
  },
  {
    icon: 'quotes-left',
    id: '.%',
    text: 'Commence par...'
  },
  {
    icon: 'quotes-right',
    id: '%.',
    text: 'Finit par...'
  },
  {
    icon: 'arrows-h',
    id: '=',
    text: 'Est exactment...'
  },
  {
    icon: 'circle-o',
    id: '0',
    text: 'Vide'
  },
  {
    icon: 'circle',
    id: '1',
    text: 'Non vide'
  }
]

function array_index (arr) {
  var index = {}

  for (var i = 0, l = arr.length; i < l; i++) {
    index[arr[i].id] = arr[i]
  }

  return index
}

// const headers_index = array_index(headers),
const search_fields_index = array_index(search_fields)
const search_fields_org_index = array_index(search_fields_org)
const search_modes_index = array_index(search_modes)
// console.log(search_fields_index)
export default {
  headers: headers,
  headers_org: headers_org,
  // headers_index: headers_index,
  search_fields: search_fields,
  search_fields_index: search_fields_index,
  search_fields_org: search_fields_org,
  search_fields_org_index: search_fields_org_index,
  search_modes: search_modes,
  search_modes_index: search_modes_index,
  get_default_search: function () {
    return {
      data: {
        field: search_fields[0].id,
        mode: search_modes[0].id,
        value: '',
        group_type_id: 0,
        org_type_id: 0,
        rel_type_id: 0
      },
      text: search_fields[0].text,
      display: '',
      id: 0,
      items: [],
      field_opened: false,
      role_opened: false,
      mode_opened: false,
      type_opened: false,
      opened: false
    }
  },
  get_default_action: function () {
    return {
      data: {
        action: 'add',
        data_type_id: 7,
        data_id: 0,
        rel_type_id: 0
      },
      type_id: 0,
      input: '',
      display: '',
      type_items: [],
      items: window.groups_index.list,
      action_opened: false,
      subject_opened: false,
      type_opened: false,
      opened: false
    }
  }
}
